import { Icon } from "@mypos/ui";
import { useOnlineStatus } from "../lib/useOnlineStatus";

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      style={{
        padding: "8px 16px",
        background: "var(--warn-soft, #FDF1E3)",
        color: "var(--warn, #B8470C)",
        borderBottom: "1px solid var(--border, #E8DFCE)",
        fontSize: 13,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Icon name="wifi-off" size="sm" />
      <strong>You're offline</strong>
      <span style={{ color: "var(--ink-2, #55504A)" }}>
        — showing cached data. Editing is paused; your Till keeps selling.
      </span>
    </div>
  );
}
